import React from 'react';

/**
 * Bordered panel with optional header row — uses `.page-panel` from PageShell.
 */
function PagePanel({ title, titleId, headerAction, children, className = '' }) {
  return (
    <section
      className={`page-panel${className ? ` ${className}` : ''}`}
      aria-labelledby={title != null && titleId ? titleId : undefined}
    >
      {(title != null || headerAction != null) && (
        <div className="page-panel__top">
          {title != null && (
            <h2 id={titleId} className="page-panel__title">
              {title}
            </h2>
          )}
          {headerAction}
        </div>
      )}
      {children}
    </section>
  );
}

export default PagePanel;
